/*
  diwali-landing.js
  Goodwork Designs — Diwali 2026 Campaign Page
  Scroll reveal + nav scroll state
*/

(function () {
  'use strict';

  // ─── Scroll Reveal ───────────────────────────────────────────────
  function initScrollReveal() {
    var elements = document.querySelectorAll('.gw-reveal');
    if (!elements.length) return;

    // Respect reduced motion preference
    var prefersReduced = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    if (prefersReduced) {
      elements.forEach(function (el) {
        el.classList.add('gw-visible');
      });

      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('gw-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.12,
        rootMargin: '0px 0px -48px 0px'
      }
    );

    elements.forEach(function (el, index) {
      el.style.transitionDelay = (index % 4) * 60 + 'ms';
      observer.observe(el);
    });
  }

  // ─── Stats Counter Animation ────────────────────────────────────
  function initCounters() {
    var statNumbers = document.querySelectorAll('.gw-stat-number');
    if (!statNumbers.length) return;

    var prefersReduced = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    if (prefersReduced) return;

    var counterObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('gw-counted');
            counterObserver.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.5
      }
    );

    statNumbers.forEach(function (el) {
      counterObserver.observe(el);
    });
  }

  // ─── Cookie Helper ──────────────────────────────────────────────
  function getCookie(name) {
    var match = document.cookie.match(
      new RegExp(
        '(?:^|; )' +
          name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') +
          '=([^;]*)'
      )
    );

    return match
      ? decodeURIComponent(match[1])
      : '';
  }

  // ─── Meta Lead Conversion API ───────────────────────────────────
  function initMetaLeadConversion() {
    /*
     * Meta Lead should ONLY run after Shopify confirms
     * that the form was successfully submitted.
     */
    if (
      !window.GW_DIWALI_CAPI ||
      !window.GW_DIWALI_CAPI.formSuccess
    ) {
      /*
       * Clear any old lead data when the page is not
       * in a successful form submission state.
       */
      sessionStorage.removeItem('gw_diwali_lead');
      return;
    }

    var storedLead = sessionStorage.getItem('gw_diwali_lead');

    if (!storedLead) {
      console.warn(
        '[Goodwork Meta CAPI] Lead data not found.'
      );

      return;
    }

    var leadData;

    try {
      leadData = JSON.parse(storedLead);
    } catch (error) {
      console.error(
        '[Goodwork Meta CAPI] Invalid stored lead data.',
        error
      );

      sessionStorage.removeItem('gw_diwali_lead');
      return;
    }

    var eventId =
      'diwali_' +
      Date.now() +
      '_' +
      Math.random().toString(36).substring(2, 12);

    /*
     * Browser-side Meta Pixel
     */
    if (typeof window.fbq === 'function') {
      window.fbq(
        'track',
        'Lead',
        {},
        {
          eventID: eventId
        }
      );
    }

    /*
     * Server-side Meta Conversions API
     */
    fetch(
      'https://korneacloud.in/goodworkdesigns/meta/lead.php',
      {
        method: 'POST',

        headers: {
          'Content-Type': 'application/json'
        },

        body: JSON.stringify({
          event_id: eventId,
          email: leadData.email,
          phone: leadData.phone,
          event_source_url: window.location.href,
          fbp: getCookie('_fbp'),
          fbc: getCookie('_fbc'),
          client_user_agent: navigator.userAgent
        })
      }
    )
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            'Meta CAPI request failed with HTTP ' +
              response.status
          );
        }

        return response.json();
      })
      .then(function (result) {
        console.log(
          '[Goodwork Meta CAPI]',
          result
        );

        /*
         * Remove stored lead data ONLY after the
         * server confirms successful processing.
         */
        if (result && result.success === true) {
          sessionStorage.removeItem(
            'gw_diwali_lead'
          );
        } else {
          console.error(
            '[Goodwork Meta CAPI] Server did not confirm success.',
            result
          );
        }
      })
      .catch(function (error) {
        /*
         * Keep the stored lead if the CAPI request fails.
         * This prevents the lead data from being silently
         * discarded when the server/API has a temporary issue.
         */
        console.error(
          '[Goodwork Meta CAPI]',
          error
        );
      });
  }

  // ─── Form Enhancement ───────────────────────────────────────────
  function initFormEnhancements() {
    var forms = document.querySelectorAll('.gw-lead-form');

    if (!forms.length) return;

    forms.forEach(function (form) {
      var submitBtn = form.querySelector(
        '.gw-form-submit-btn'
      );

      if (!submitBtn) return;

      /*
       * Validate the form when the submit button is clicked.
       *
       * This gives us custom validation feedback before
       * the browser proceeds with the form submission.
       */
      submitBtn.addEventListener('click', function (e) {
        var requiredFields =
          form.querySelectorAll('[required]');

        var firstInvalidField = null;
        var formIsValid = true;

        requiredFields.forEach(function (field) {
          validateField(field);

          if (!field.checkValidity()) {
            formIsValid = false;

            if (!firstInvalidField) {
              firstInvalidField = field;
            }
          }
        });

        /*
         * Stop submission when any required field
         * is missing or invalid.
         */
        if (!formIsValid) {
          e.preventDefault();

          if (firstInvalidField) {
            firstInvalidField.focus();
          }

          return;
        }
      });

      /*
       * Form submission handler.
       *
       * This is the second validation layer and makes sure
       * lead data is stored ONLY when the form is valid.
       */
      form.addEventListener('submit', function (e) {
        var requiredFields =
          form.querySelectorAll('[required]');

        var firstInvalidField = null;
        var formIsValid = true;

        requiredFields.forEach(function (field) {
          validateField(field);

          if (!field.checkValidity()) {
            formIsValid = false;

            if (!firstInvalidField) {
              firstInvalidField = field;
            }
          }
        });

        /*
         * Invalid form:
         * - Stop Shopify submission
         * - Do not store lead data
         * - Do not trigger Meta CAPI
         */
        if (!formIsValid) {
          e.preventDefault();

          if (firstInvalidField) {
            firstInvalidField.focus();
          }

          return;
        }

        /*
         * Form is valid.
         *
         * Only now capture the lead information.
         */
        var emailField = form.querySelector(
          '[name="contact[email]"]'
        );

        var phoneField = form.querySelector(
          '[name="contact[phone]"]'
        );

        var email = emailField
          ? emailField.value.trim()
          : '';

        var phone = phoneField
          ? phoneField.value.trim()
          : '';

        var formType = form.classList.contains(
          'gw-popup-form'
        )
          ? 'popup'
          : 'main';

        sessionStorage.setItem(
          'gw_diwali_lead',
          JSON.stringify({
            email: email,
            phone: phone,
            form_type: formType
          })
        );

        /*
         * Existing visual feedback.
         */
        var originalText =
          submitBtn.textContent;

        submitBtn.textContent = 'Sending…';
        submitBtn.disabled = true;

        /*
         * Re-enable after 8 seconds as failsafe.
         */
        setTimeout(function () {
          if (submitBtn.disabled) {
            submitBtn.textContent = originalText;
            submitBtn.disabled = false;
          }
        }, 8000);
      });

      /*
       * Live validation.
       *
       * Validate required fields on blur and update
       * the validation state while the user is typing.
       */
      var requiredFields =
        form.querySelectorAll('[required]');

      requiredFields.forEach(function (field) {
        field.addEventListener('blur', function () {
          validateField(field);
        });

        field.addEventListener(
          'input',
          function () {
            if (
              field.classList.contains(
                'gw-field-error'
              )
            ) {
              validateField(field);
            }
          }
        );

        /*
         * Also handle select/dropdown changes.
         */
        field.addEventListener(
          'change',
          function () {
            validateField(field);
          }
        );
      });
    });
  }

  // ─── Field Validation ───────────────────────────────────────────
  function validateField(field) {
    var isValid = field.checkValidity();

    field.classList.toggle(
      'gw-field-error',
      !isValid
    );

    field.classList.toggle(
      'gw-field-valid',
      isValid &&
        field.value.trim() !== ''
    );
  }

  // ─── Smooth Scroll for Anchor Links ─────────────────────────────
  function initSmoothScroll() {
    document
      .querySelectorAll('a[href^="#"]')
      .forEach(function (anchor) {
        anchor.addEventListener(
          'click',
          function (e) {
            var target = document.querySelector(
              this.getAttribute('href')
            );

            if (!target) return;

            e.preventDefault();

            var offset = 80;

            var top =
              target.getBoundingClientRect()
                .top +
              window.pageYOffset -
              offset;

            window.scrollTo({
              top: top,
              behavior: 'smooth'
            });

            /*
             * Focus the form card for accessibility.
             */
            if (
              this.getAttribute('href') ===
              '#get-quote'
            ) {
              setTimeout(function () {
                var firstInput =
                  target.querySelector(
                    'input, select, textarea'
                  );

                if (firstInput) {
                  firstInput.focus();
                }
              }, 600);
            }
          }
        );
      });
  }

  // ─── Industry Popup Modal ───────────────────────────────────────
  function initIndustryPopup() {
    var modal = document.getElementById(
      'gw-industry-modal'
    );

    if (!modal) return;

    var cards = document.querySelectorAll(
      '.gw-industry-card'
    );

    var closeBtn = modal.querySelector(
      '.gw-industry-modal-close'
    );

    var backdrop = modal.querySelector(
      '.gw-industry-modal-backdrop'
    );

    var industryInput =
      document.getElementById(
        'gw-popup-industry'
      );

    function openModal(industry) {
      modal.classList.add(
        'gw-modal-active'
      );

      document.body.classList.add(
        'gw-modal-open'
      );

      if (industryInput) {
        industryInput.value = industry;
      }
    }

    function closeModal() {
      modal.classList.remove(
        'gw-modal-active'
      );

      document.body.classList.remove(
        'gw-modal-open'
      );
    }

    cards.forEach(function (card) {
      card.addEventListener(
        'click',
        function () {
          openModal(
            card.dataset.industry || ''
          );
        }
      );
    });

    if (closeBtn) {
      closeBtn.addEventListener(
        'click',
        closeModal
      );
    }

    if (backdrop) {
      backdrop.addEventListener(
        'click',
        closeModal
      );
    }

    document.addEventListener(
      'keydown',
      function (e) {
        if (e.key === 'Escape') {
          closeModal();
        }
      }
    );
  }

  // ─── Init ────────────────────────────────────────────────────────
  function init() {
    initScrollReveal();
    initCounters();
    initFormEnhancements();
    initSmoothScroll();
    initIndustryPopup();
    initMetaLeadConversion();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }
})();